import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	pageContainer: {
		flexDirection: "column",
		margin: "10% 0"
	},
	button: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			color: colors.getPrimaryColor(),
			opacity: 0.9
		}
	},
	contentContainer: {
		display: "flex",
		justifyContent: "center"
	},
	tokenItem: {
		width: "100%",
		margin: "0 20%"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
}))

export default useStyles
